@if (videoUrl) {
  @if (block.data.type === 'inline') {
    <div class="video-wrapper">
      @if (block.data.type === 'inline') {
        <div
          [ngClass]="{ video: !block.data.html5Video }"
          class="video-inline {{ !block.data.html5Video ? block.data.ratio : '' }}">
          @if (!block.data.html5Video) {
            <iframe
              [src]="videoUrl"
              allow="fullscreen"
              id="video-player-{{ block.uid }}"
              name="{{ block.data.config.player.name }}"></iframe>
          }
          @if (block.data.html5Video) {
            <video
              [attr.data-account]="block.data.accountId"
              [attr.data-video-id]="block.data.id"
              class="video-js {{ block.data.ratio }}"
              controls
              data-embed="default"
              data-player="default"
              id="video-player-{{ block.uid }}"></video>
          }
        </div>
      }
      @if (block.data.type === 'inline' && block.data.text) {
        <p [innerHtml]="block.data.text"></p>
      }
    </div>
  }

  @if (block.data.type === 'modal') {
    <a
      [core-analytics]="{ action: block.data.text, block }"
      class="video-modal-link"
      data-target="#video-modal-{{ block.uid }}"
      data-toggle="modal"
      href="javascript:void(0)">
      @if (block.data.image || (block.data.isApiImage && block.data.apiImage)) {
        <div class="video {{ block.data.ratio }}">
          <img
            [src]="block.data.isApiImage && block.data.apiImage ? block.data.apiImage : block.data.image"
            alt="Close video"
            class="img-responsive" />
        </div>
      }
      @if (block.data.text) {
        <p [innerHtml]="block.data.text"></p>
      }
    </a>
  }

  @if (block.data.type === 'modal') {
    <div
      class="modal fade"
      data-backdrop="static"
      data-keyboard="false"
      id="video-modal-{{ block.uid }}"
      role="dialog"
      tabindex="-1">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              (click)="closeModal()"
              aria-label="Close"
              class="btn-close"
              data-bs-dismiss="modal"
              type="button"></button>
          </div>
          <div class="modal-body">
            <div
              [ngClass]="{ video: !block.data.html5Video }"
              class="{{ !block.data.html5Video ? block.data.ratio : '' }}">
              @if (!block.data.html5Video) {
                <iframe
                  [attr.allowFullScreen]="block.data.config.player.allowfullscreen"
                  [src]="videoUrl"
                  frameborder="0"
                  id="video-player-{{ block.uid }}"
                  name="{{ block.data.config.player.name }}"
                  scrolling="no"></iframe>
              }
              @if (block.data.html5Video) {
                <video
                  [attr.data-account]="block.data.accountId"
                  [attr.data-video-id]="block.data.id"
                  allow="fullscreen"
                  class="video-js  {{ block.data.ratio }}"
                  controls
                  data-embed="default"
                  data-player="default"
                  id="video-player-{{ block.uid }}"></video>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}
